module.exports = __webpack_public_path__ + "static/voucher_type-8b043fd49f05baeb63f690a1cf35e432.png";